// extracted by mini-css-extract-plugin
export default {"container":"TE-z","dimension":"UE-z","dimensionLabels":"VE-z"};